/*
 *
 * ZendeskVerify constants
 *
 */

import { defineApiActionTypes } from 'utils/action-helper';
const prefix = 'ui/containers/ZendeskVerify';

/*
 * @dev defineApiActionTypes a function that
 * return concat base with START,SUCCESS,FAILURE
 */
export const VERIFY_ZENDESK = defineApiActionTypes(`${prefix}/VERIFY_ZENDESK_START`);
